import { Injectable, inject } from '@angular/core';
import { IListado, IQueryParam, ILecturaPortico } from 'modelos/src';
import { Observable, from } from 'rxjs';
import { HelperService } from '../../auxiliares/servicios/helper.service';
import { HttpApiAdminService } from '../../auxiliares/servicios/http-api.service';
import { StorageService } from '../../auxiliares/servicios/storage.service';

@Injectable({
  providedIn: 'root',
})
export class LecturaPorticoService {
  private http = inject(HttpApiAdminService);
  private helper = inject(HelperService);
  private storage = inject(StorageService);

  public listar(
    queryParams?: IQueryParam,
  ): Observable<IListado<ILecturaPortico>> {
    let params = this.helper.getQueryParams(queryParams);
    return this.http.get(`/lecturaPorticos`, { params });
  }

  public listarPorId(id: string): Observable<ILecturaPortico> {
    return this.http.get(`/lecturaPorticos/${id}`);
  }

  public subirImagen(
    file: File,
    nombreCLiente: string,
    nombreImagen: string,
    nombreCategoria?: string,
  ): Observable<{ url: string }> {
    return from(
      this.storage.subirImagenCliente(
        file,
        nombreCLiente,
        nombreImagen,
        nombreCategoria,
      ),
    );
  }

  public subirImagenPublica(
    file: File,
    fileName: string,
  ): Observable<{ url: string }> {
    return from(this.storage.subirImagenPublica(file, fileName));
  }
}
